import logo from "../../assets/images/logo.svg";
import loginLeftBg from "../../assets/images/login-left-section.svg";

let preloaded = false;

export function preloadAuthAssets() {
  if (preloaded || typeof window === "undefined") return;
  preloaded = true;

  for (const href of [loginLeftBg, logo]) {
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "image";
    link.href = href;
    document.head.appendChild(link);
  }
}
